export class ImageHotspotManager {
    private hotspotContentWrapper: HTMLElement;

    constructor(wrapper: HTMLElement) {
        this.hotspotContentWrapper = wrapper.querySelector(
            '.gw-hotspot-image__popups'
        ) as HTMLElement;
    }

    private setupEventListener(): void {
        document.addEventListener('click', (event) => {
            const target = event.target as HTMLElement;

            const marker = target.closest(
                '.gw-hotspot-image__marker'
            ) as HTMLElement;

            const allCards = this.hotspotContentWrapper.querySelectorAll(
                '.gw-hotspot-image__card'
            );

            if (marker && marker.id) {
                // Marker clicked
                const targetId = marker.getAttribute('data-target-id');
                if (targetId) {
                    const targetCard = this.hotspotContentWrapper.querySelector(
                        `#${targetId}`
                    ) as HTMLElement;

                    if (targetCard) {
                        allCards.forEach((card) => {
                            card.classList.add('is-hidden'); //hides all the cards
                        });

                        targetCard.classList.remove('is-hidden'); // shows the clicked card
                    }
                }
            } else {
                // Clicked outside a marker — hide all
                allCards.forEach((card) => {
                    card.classList.add('is-hidden');
                });
            }
        });
    }

    public static init(): void {
        const hotspotWrappers =
            document.querySelectorAll<HTMLElement>('.gw-hotspot-image');

        hotspotWrappers.forEach((wrapper) => {
            const manager = new ImageHotspotManager(wrapper);
            //setup data-target-id attributes for each hotspot marker
            const markers = wrapper.querySelectorAll(
                '.gw-hotspot-image__marker'
            );
            markers.forEach((marker, index) => {
                marker.setAttribute(
                    'data-target-id',
                    `gw-hotspot-image__card-${index + 1}`
                );
            });
            manager.setupEventListener();
        });
    }
}
